import React, {forwardRef, useImperativeHandle, useState} from 'react';
import styled  from 'styled-components';
// import Img1 from '../../active_135/imgs/bg3.png'
// import Img1  from './../images/bg2.png';
import Img1 from '../images/bg2.png'
import bridge from '@/config/JSbridge'
// import { fetchScreenDetain } from "../api"
const Comfirm = forwardRef((props,ref) => {
  const [visible, setVisible] = useState(false);
  function show() {
    setVisible(true);
  }
  useImperativeHandle(ref, () => ({
    show
  }));
  function close () {
    props.detain();
    setVisible(false);
  }
  
 
  function liveApp() {
    setVisible(false);
    bridge.callHandler('nativeEvent', {event: 'close', params: {
      isDelete: false
    }}, () => {})
  }
  return (
    <ComfirmContainer className={visible?'':'hide'} onClick={()=>close()}>
      <div className='bg1'  >
        <div className='content' onClick={(e)=>{e.stopPropagation()}}>
          <div className='content1'>加增3个月时长</div>
          <div className='content2'>专属涨停大礼包</div>
         
        </div>
        <div className='footer'>

          <div><img onClick={()=> close()} src={require('../images/btn2.png')} alt=""/></div>
          <div><img onClick={()=> liveApp()} src={require('../images/btn3.png')} alt=""/></div>

        </div>
        
        
      </div>
     
    </ComfirmContainer>
  )
})

export default Comfirm;

const ComfirmContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0, 0.82);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  &.hide {
    display: none;
  }
 .title {
    font-weight: bold;
    font-size: 30px;
    color: #000000;
    line-height: 45px;
    .money {
      font-size: 44px;
      color: #ED3535;
    }
  }
  .bg1 {
    width: 84vw;
    height: 109vw;
    margin: auto;
    background-image: url(${Img1});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .content {
      box-sizing: border-box;
      padding: 120px 23px 0;
    }
  }
  .tips {
    margin-top:10px;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 21px;
    width: 275px;
    box-sizing: border-box;
    .name {
      font-weight: bold;
    }
    .money {
      color: #FD3032;
    }
    p {
      line-height: 1.1;
    }
  }
  .content {
    position: relative;
     width: 100%;
  }
  .content1 {
    position: absolute;
    left:34vw;
    color: #fff;
    font-size: 6vw;
    top: 55vw;
  }
  .content2 {
    position: absolute;
    left:34vw;
    color: #fff;
    font-size: 6vw;
    top: 74vw;
  }
  
  .footer {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    position: absolute;
    left: 0;
    bottom: 2vw;
    z-index:1;
   >div {

    margin-bottom: 11px;
   }
    img {
      height: 40px;
      // width: 100%;
    }
  }
  .close {
    position: absolute;
    margin: auto;
    text-align: center;
    left: 50%;
    transform:translatex(-50%);
    bottom: -30px;
    color: #898989;
    text-decoration: underline;
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_139/components/Detention.js